<script setup lang="ts">
import { formatBytes } from '@/utils/format';
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  color?: string;
  attachmentFiles?: File[];
  deleteFiles?: (index: number) => void;
  isHideThead?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  color: undefined,
  attachmentFiles: () => [],
  deleteFiles: undefined,
  isHideThead: false,
});
</script>

<template>
  <table
    data-testid="attachmentsCustomTable"
    :class="$style.attachmentsCustomTable"
  >
    <thead v-if="!props.isHideThead">
      <tr>
        <th :class="$style.nameTh">Name</th>
        <th :class="$style.sizeTh">Size</th>
        <th :class="$style.deleteTh">Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(file, index) in attachmentFiles" :key="index">
        <td :class="$style.nameTd"> {{ file.name }} </td>
        <td :class="$style.sizeTd"> {{ formatBytes(file.size) }} </td>
        <td :class="$style.deleteTd">
          <KBtn
            icon="mdi-delete-outline"
            variant="text"
            priority="danger"
            size="xs"
            :class="$style.delBtn"
            :disabled="!props.deleteFiles"
            @click="props.deleteFiles && props.deleteFiles(index)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.attachmentsCustomTable {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;

  th, td {
    padding: 4px;
    vertical-align: top;
  }
  th:first-child,
  td:first-child {
    padding-left: 0;
  }
  th:last-child,
  td:last-child {
    padding-right: 0;
  }
  tbody > tr:first-child > td {
    padding-top: 12px;
  }
  thead > tr > th:last-child {
    text-align: right;
  }
  tbody > tr > td:last-child {
    text-align: center;
  }

  thead {
    color: colors.$color-text-tertiary;
    font-size: 12px;
    letter-spacing: -0.5px;

    th {
      font-weight: normal;
      border-bottom: 1px solid colors.$color-gray-200;
    }
  }
  tbody {
    color: colors.$color-text-primary;
  }
}
  .nameTh {
    min-width: 100%;
    width: 100%;
  }
  .sizeTh {
  }
  .deleteTh {
  }
  .nameTd {
    word-break: break-word;
    min-width: 100%;
    width: 100%;
  }
  .sizeTd {
    white-space: nowrap;
  }
  .deleteTd {
  }

  .delBtn {
    margin: -13px 0 -7px 0;
  }
</style>
